import { TestSMS } from 'widgets/TestSMS'
import { useBroadcastDetailModalContext } from 'pages/broadcasts/ui/BroadcastActions/ui/BroadcastDetailModal/context/context'
import { broadcastActionsStore } from 'pages/broadcasts/ui/BroadcastActions'

export const TestContent = () => {
  const broadcast = useBroadcastDetailModalContext()

  return (
    <TestSMS
      params={broadcast.testSMSParams}
      request={broadcastActionsStore.onTestSMSBroadcast}
      isTopError
      disabled={broadcast.isInvalid}
    />
  )
}
